import React, { useEffect, useState } from 'react';
import { APIURL } from '../../configApi/apiConfig';
import axios from '../../configApi/axiosConfig';

const nuevoFormulario = {
	Accion: '',
	InternoExterno: '1',
	Tipo: '1'
};

const tiposAccion = [
	{ id: 1, nombre: 'Telefonico' },
	{ id: 2, nombre: 'Terreno' },
	{ id: 3, nombre: 'Telematico' }
];

const obtenerNombreTipo = (tipoId) => {
	const encontrado = tiposAccion.find((item) => item.id === Number(tipoId));
	return encontrado ? encontrado.nombre : tipoId;
};

const obtenerNombreInternoExterno = (valor) => {
	const numero = Number(valor);
	if (numero === 1) return 'Interno';
	if (numero === 2) return 'Externo';
	return valor;
};

const normalizarRespuesta = (respuesta) => {
	if (Array.isArray(respuesta)) return respuesta;
	if (Array.isArray(respuesta?.data)) return respuesta.data;
	if (respuesta?.data && typeof respuesta.data === 'object') return [respuesta.data];
	if (respuesta && typeof respuesta === 'object') return [respuesta];
	return [];
};

export function NewAcciones() {
	const [registros, setRegistros] = useState([]);
	const [formData, setFormData] = useState(nuevoFormulario);
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState('');
	const [editingId, setEditingId] = useState(null);
	const [confirmDeleteId, setConfirmDeleteId] = useState(null);
	const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

	useEffect(() => {
		fetchAcciones();
	}, []);

	useEffect(() => {
		if (!toast.show) {
			return undefined;
		}

		const timer = setTimeout(() => {
			setToast((prev) => ({ ...prev, show: false }));
		}, 3500);

		return () => clearTimeout(timer);
	}, [toast.show]);

	const mostrarToast = (type, message) => {
		setToast({ show: true, type, message });
	};

	const fetchAcciones = async () => {
		try {
			setLoading(true);
			const response = await axios.get(APIURL.getcbo_acciones_all());
			setRegistros(normalizarRespuesta(response.data));
		} catch (fetchError) {
			console.error('Error al cargar acciones:', fetchError);
			setRegistros([]);
			mostrarToast('error', 'No se pudo cargar la información.');
		} finally {
			setLoading(false);
		}
	};

	const manejarCambio = (event) => {
		const { name, value } = event.target;
		setFormData((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const limpiarFormulario = () => {
		setFormData(nuevoFormulario);
		setEditingId(null);
		setError('');
	};

	const validarFormulario = () => {
		if (!formData.Accion || !String(formData.Accion).trim()) {
			setError('El campo Acción es obligatorio.');
			return false;
		}

		if (formData.InternoExterno === '' || formData.Tipo === '') {
			setError('Completa los campos Interno/Externo y Tipo.');
			return false;
		}

		return true;
	};

	const guardarRegistro = async (event) => {
		event.preventDefault();
		setError('');

		if (!validarFormulario()) {
			return;
		}

		const payload = {
			Accion: formData.Accion.trim().toUpperCase(),
			InternoExterno: Number(formData.InternoExterno),
			Tipo: Number(formData.Tipo)
		};

		try {
			setSaving(true);
			if (editingId) {
				await axios.patch(APIURL.patch_cbo_acciones(editingId), payload);
				mostrarToast('success', 'Acción actualizada correctamente.');
			} else {
				await axios.post(APIURL.post_cbo_acciones(), payload);
				mostrarToast('success', 'Acción creada correctamente.');
			}

			await fetchAcciones();
			limpiarFormulario();
		} catch (saveError) {
			console.error('Error al guardar acción:', saveError);
			setError('Hubo un error al guardar el registro.');
			mostrarToast('error', 'No se pudo guardar el registro.');
		} finally {
			setSaving(false);
		}
	};

	const cargarParaEditar = (item) => {
		setEditingId(item.sCbo_Acciones);
		setFormData({
			Accion: item.Accion || '',
			InternoExterno: String(item.InternoExterno ?? '1'),
			Tipo: String(item.Tipo ?? '1')
		});
		setError('');
	};

	const eliminarRegistro = async (sCbo_Acciones) => {
		try {
			await axios.delete(APIURL.delete_cbo_acciones(sCbo_Acciones));
			setRegistros((prev) => prev.filter((item) => item.sCbo_Acciones !== sCbo_Acciones));
			mostrarToast('success', 'Acción eliminada correctamente.');
		} catch (deleteError) {
			console.error('Error al eliminar acción:', deleteError);
			setError('Hubo un error al eliminar el registro.');
			mostrarToast('error', 'No se pudo eliminar el registro.');
		}
	};

	const confirmarEliminacion = async () => {
		if (!confirmDeleteId) return;
		const id = confirmDeleteId;
		setConfirmDeleteId(null);
		await eliminarRegistro(id);
	};

	const registroAEliminar = registros.find((item) => item.sCbo_Acciones === confirmDeleteId);

	return (
		<div className="p-4 md:p-6 bg-gray-50 min-h-screen">
			<div className="max-w-7xl mx-auto space-y-5">
				{toast.show && (
					<div className={`fixed top-5 right-5 z-50 px-4 py-3 rounded-xl shadow-lg text-sm text-white ${toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
						{toast.message}
					</div>
				)}

				<div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
					<h2 className="text-2xl font-bold text-primaryBlue">Mantenimiento Acciones</h2>
					<p className="text-sm text-gray-500 mt-1">Inserta, actualiza y elimina acciones de cobranza.</p>
				</div>

				<form onSubmit={guardarRegistro} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
					<h3 className="text-lg font-semibold text-gray-800 mb-4">{editingId ? 'Editar acción' : 'Nueva acción'}</h3>
					<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Acción</label>
							<input
								type="text"
								name="Accion"
								value={formData.Accion}
								onChange={manejarCambio}
								className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
							/>
						</div>
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Interno / Externo</label>
							<select
								name="InternoExterno"
								value={formData.InternoExterno}
								onChange={manejarCambio}
								className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
							>
								<option value="1">1 - Interno</option>
								<option value="2">2 - Externo</option>
							</select>
						</div>
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
							<select
								name="Tipo"
								value={formData.Tipo}
								onChange={manejarCambio}
								className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primaryBlue"
							>
								{tiposAccion.map((tipo) => (
									<option key={tipo.id} value={String(tipo.id)}>
										{tipo.id}: {tipo.nombre}
									</option>
								))}
							</select>
						</div>
					</div>

					{error && <p className="text-red-600 text-sm mt-3">{error}</p>}

					<div className="flex items-center gap-2 mt-5">
						<button
							type="submit"
							disabled={saving}
							className="bg-primaryBlue text-white px-4 py-2 rounded-xl text-sm hover:opacity-90 disabled:opacity-50"
						>
							{saving ? 'Guardando...' : editingId ? 'Actualizar' : 'Agregar'}
						</button>
						<button
							type="button"
							onClick={limpiarFormulario}
							className="border border-gray-300 text-gray-700 px-4 py-2 rounded-xl text-sm hover:bg-gray-50"
						>
							{editingId ? 'Cancelar edición' : 'Limpiar'}
						</button>
						<button
							type="button"
							onClick={fetchAcciones}
							className="border border-gray-300 text-gray-700 px-4 py-2 rounded-xl text-sm hover:bg-gray-50"
						>
							Recargar
						</button>
					</div>
				</form>

				<div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
					{loading && <p className="text-sm text-gray-500 mb-3">Cargando acciones...</p>}

					<div className="overflow-x-auto rounded-xl border border-gray-100">
						<table className="min-w-full text-sm">
							<thead>
								<tr className="bg-gray-100 text-gray-700">
									<th className="px-3 py-2 text-left">#</th>
									<th className="px-3 py-2 text-left">Acción</th>
									<th className="px-3 py-2 text-left">InternoExterno</th>
									<th className="px-3 py-2 text-left">Tipo</th>
									<th className="px-3 py-2 text-left">Acciones</th>
								</tr>
							</thead>
							<tbody>
								{registros.length === 0 ? (
									<tr>
										<td className="px-3 py-4 text-center text-gray-500" colSpan={5}>
											No hay datos cargados.
										</td>
									</tr>
								) : (
									registros.map((item, index) => (
										<tr key={item.sCbo_Acciones || `${item.Accion}-${index}`} className="border-b border-gray-100">
											<td className="px-3 py-2">{index + 1}</td>
											<td className="px-3 py-2 font-medium text-gray-800">{item.Accion}</td>
											<td className="px-3 py-2">{obtenerNombreInternoExterno(item.InternoExterno)}</td>
											<td className="px-3 py-2"> {obtenerNombreTipo(item.Tipo)}</td>
											<td className="px-3 py-2">
												<div className="flex items-center gap-2">
													<button
														type="button"
														onClick={() => cargarParaEditar(item)}
														className="text-blue-600 hover:text-blue-800 font-medium"
													>
														Editar
													</button>
													<button
														type="button"
														onClick={() => setConfirmDeleteId(item.sCbo_Acciones)}
														className="text-red-600 hover:text-red-800 font-medium"
													>
														Eliminar
													</button>
												</div>
											</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
				</div>

				{confirmDeleteId && (
					<div className="fixed inset-0 z-40 bg-black/40 flex items-center justify-center p-4">
						<div className="bg-white rounded-2xl shadow-xl border border-gray-200 w-full max-w-md p-5">
							<h4 className="text-lg font-semibold text-gray-800">Confirmar eliminación</h4>
							<p className="text-sm text-gray-600 mt-2">¿Seguro que deseas eliminar este registro?</p>
							<div className="mt-3 rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm text-gray-700">
								<p><span className="font-semibold">Acción:</span> {registroAEliminar?.Accion || '-'}</p>
								<p><span className="font-semibold">Tipo:</span> {registroAEliminar?.Tipo ?? '-'}</p>
							</div>
							<div className="flex justify-end gap-2 mt-5">
								<button
									type="button"
									onClick={() => setConfirmDeleteId(null)}
									className="border border-gray-300 text-gray-700 px-4 py-2 rounded-xl text-sm hover:bg-gray-50"
								>
									Cancelar
								</button>
								<button
									type="button"
									onClick={confirmarEliminacion}
									className="bg-red-600 text-white px-4 py-2 rounded-xl text-sm hover:bg-red-700"
								>
									Eliminar
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
